import React, { useState, useEffect } from "react";
import { Route, Link, Switch, useParams} from "react-router-dom";
import quizService from "../../services/quiz.service";
import '../../util/Quiz.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faTrash } from '@fortawesome/free-solid-svg-icons';
import CreateQuestionModal from "../question/question.create.component";
import EditQuestionModal from "../question/question.edit.component";
import Select from 'react-select'

const QuizEdit = () => {
  const [loading, setLoading] = useState(true);
  const [currentQuiz, setCurrentQuiz] = useState(null);
  const [quizQuestions, setQuizQuestions] = useState([]);
  const [quizTitle, setQuizTitle] = useState("");
  const [quizCourse, setQuizCourse] = useState("");
  const [quizNumQuestions, setQuizNumQuestions] = useState(0);
  const [showQuestionCreateModal, setShowQuestionCreateModal] = useState(false);
  const [showQuestionEditModal, setShowQuestionEditModal] = useState(false);
  const [selectedQuestion, setSelectedQuestion] = useState(null);
  const [isPublic, setIsPublic] = useState(false);

  const topic_options = [
    { value: 'query', label: 'Query' },
    { value: 'data_cln', label: 'Data Cleaning' },
    { value: 'data_pro', label: 'Data Preprocessing' },
    { value: 'data_viz', label: 'Data Visualization' },
    { value: 'feat_eng', label: 'Feature Engineering' },
    { value: 'feat_sel', label: 'Feature Selection' },
    { value: 'analysis', label: 'Analysis' }
  ]

  const { id } = useParams();
  useEffect(() => {
    const fetchQuiz = async (quiz_id) => {
      const author = JSON.parse(localStorage.getItem("user")).username;
      try {
        const response = await quizService.getQuizEdit(author, quiz_id);
        
  setCurrentQuiz(response.quiz);
  setQuizQuestions([...quizQuestions, ...response.questions]);
  setQuizTitle(response.quiz.title);
  setQuizCourse(response.quiz.course);
  setIsPublic(!!response.quiz.public);
  console.log("Course resp:", response.quiz.course);
  setLoading(false);
  console.log(response.questions);
      } catch (error) {
        console.error("Error Getting the quiz:", error);
        setLoading(false);
      }
    };
    fetchQuiz(id);
  }, []);

  if (loading) {
    return <p>Loading quizzes...</p>;
  }

  const handleQuizEdit = async (quizObj) => {
    try {
      await quizService.postQuizEdit(quizObj)
      window.location.reload();
    } catch (error) {
      console.error("Error creating quiz:", error);
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault();

    const author = JSON.parse(localStorage.getItem("user")).username;
    // Create quiz object
  const newQuiz = {
    id: currentQuiz._id.$oid,
    title: quizTitle.trim(),
    course: quizCourse.trim(),
    author: author,
    questions: quizQuestions,
    public: isPublic,
  };
    // debugger;
    handleQuizEdit(newQuiz);
    // Close the modal
    // setIsOpen(false);
  };

  const handleEditClick = (qn_obj) => {
    setShowQuestionEditModal(true);
    setSelectedQuestion(qn_obj);
  };

  const handleDeleteClick = (qn_obj) => {
    // Display a confirmation dialog
    const shouldDelete = window.confirm("Are you sure you want to delete this question?");
    if (shouldDelete) {
      handleDeleteQuizQuestion(qn_obj);
    } else {
      // Optionally handle cancellation
      console.log("Deletion canceled.");
    }
  };

  

  const handleCreateQuizQuestion = async (questionObj) => {
    try {
      const response = await quizService.createQuizQuestion(questionObj);
      console.log("create_qn_resp: ", response.question);
      response.question.id = response.question._id.$oid,
      setQuizQuestions([...quizQuestions, response.question]);
    } catch (error) {
      console.error("Error creating question:", error);
      console.log("QuestionObjEoor: ", questionObj);
    }
}

  const handleEditQuizQuestion = async (questionObj) => {
    try {
      const response = await quizService.editQuizQuestion(questionObj);
      console.log("edit_qn_resp: ", response.question);
      response.question.id = response.question._id.$oid,
      setQuizQuestions(prevQuestions =>
        prevQuestions.map(q =>
          q.id === response.question.id ? response.question : q
        )
      );
    } catch (error) {
      console.error("Error editing question:", error);
      console.log("QuestionObjEoor: ", questionObj);
    }
};

const handleDeleteQuizQuestion = async (questionObj) => {
  try {
      const response = await quizService.deleteQuizQuestion(questionObj);
      console.log("delete_qn_resp: ", response);
      setQuizQuestions(prevQuestions => 
          prevQuestions.filter(q => q.id !== questionObj.id)
      );
  } catch (error) {
      console.error("Error deleting question:", error);
  }
};

  return (
    <div className="quiz_edit_body">
      <div className="quiz_header">
        <h2>Edit Quiz</h2>
      </div>
    <div className="quiz_form">
    <label>Quiz Title:</label>
    <input
      type="text"
      placeholder="Title"
      value={quizTitle}
      onChange={(e) => setQuizTitle(e.target.value)}
      required
    />
    <label>Topic:</label>
    <Select options={topic_options}
          placeholder="Select Topic ..."
          required
          defaultValue={topic_options.find(({ value }) => value === quizCourse)}
          onChange={(e) => setQuizCourse(e.value)}/>
    <label style={{marginTop: '10px'}}>
      <input
        type="checkbox"
        checked={isPublic}
        onChange={e => setIsPublic(e.target.checked)}
        style={{ marginRight: '8px' }}
      />
  Public (visible to all students)
        
    </label>
    </div>

      <div className="quiz_header mt-2" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <h2 style={{ margin: 0 }}>Questions:</h2>
        <button type="button" 
            onClick={() => setShowQuestionCreateModal(true)}
            className="btn btn-secondary">
            Create New
        </button>
      </div>

      {quizQuestions &&
        quizQuestions.map((obj, i) => (
          <div key={obj.id} style={{ marginBottom: '20px' }}>
            <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
              <div style={{ flex: 1, display: 'flex' }}>
                <span className="quiz-page-option-prompt quiz-page-radio-input-prompt" style={{ marginRight: '5px' }}>{i+1}. </span>
                <span className="quiz-page-option-prompt quiz-page-radio-input-prompt" style={{ wordWrap: 'break-word' }}>{obj.prompt}</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <button onClick={() => handleEditClick(obj)} 
                  style={{ border: 'none', background: 'none', cursor: 'pointer', color: 'blue', marginRight: '10px' }}>
                  <FontAwesomeIcon icon={faPen} />
                </button>
                <button onClick={() => handleDeleteClick(obj)} 
                  style={{ border: 'none', background: 'none', cursor: 'pointer', color: 'red' }}>
                  <FontAwesomeIcon icon={faTrash} />
                </button>
              </div>
            </div>
            <hr style={{ border: 'none', borderTop: '1px solid #ccc', marginTop: '10px' }} />
          </div>
      ))}

      <div 
        className="button-container">
        <button onClick={handleSubmit} type="submit">Submit</button>
      </div>

      {showQuestionCreateModal && (
        <CreateQuestionModal
            isOpen={showQuestionCreateModal}
            setIsOpen={setShowQuestionCreateModal}
            onCreateQuestion={handleCreateQuizQuestion}
        />
      )}

      {showQuestionEditModal && (
        <EditQuestionModal
            isOpen={showQuestionEditModal}
            setIsOpen={setShowQuestionEditModal}
            onEditQuestion={handleEditQuizQuestion}
            question_obj={selectedQuestion}
        />
      )}


    </div>
    
  )
};

export default QuizEdit;
